module.exports = __webpack_public_path__ + "img/patrick-base_frame_0.88c50850.png";